<script lang="ts">
    import { Creatures, Filters, isBestiaryVisible } from "./store";
    import BESTIARY from "./bestiary";
    import { onDestroy } from "svelte";
    import DifficultyFilter from "./DifficultyFilter.svelte";
    import { uniqueCreatures } from "./functions";

    let searchText = "";

    function filterCreatures() {
        Creatures.update(() => {
            let filteredCreatures = [...BESTIARY];
            let filters = $Filters;

            if (Object.values(filters.books).includes(false)) {
                filteredCreatures = filteredCreatures.filter(
                    (creature) => filters.books[creature.book]
                );
            }

            filteredCreatures = filteredCreatures.filter((creature) =>
                creature.name.toLowerCase().includes(searchText.toLowerCase())
            );

            filteredCreatures = filteredCreatures.filter(
                ({ difficulty }) =>
                    difficulty >= filters.difficulty["min"] &&
                    difficulty <= filters.difficulty["max"]
            );

            if (filters.horrifying) {
                filteredCreatures = filteredCreatures.filter(
                    ({ horrifying }) => horrifying
                );
            }

            if (filters.frightening) {
                filteredCreatures = filteredCreatures.filter(
                    ({ frightening }) => frightening
                );
            }

            if (filters.magic) {
                filteredCreatures = filteredCreatures.filter(
                    ({ hasMagic }) => hasMagic
                );
            }

            filteredCreatures = filteredCreatures.filter(
                ({ difficulty }) =>
                    difficulty >= $Filters.difficulty["min"] &&
                    difficulty <= $Filters.difficulty["max"]
            );

            if (Object.values(filters.descriptors).includes(true)) {
                filteredCreatures = filteredCreatures.filter((creature) => {
                    let containedInFilter = false;
                    creature.descriptors.forEach((descriptor) => {
                        if (filters.descriptors[descriptor]) {
                            containedInFilter = true;
                            return;
                        }
                    });
                    return containedInFilter;
                });
            }
            isBestiaryVisible.set(true);
            return uniqueCreatures(filteredCreatures);
        });
    }

    function setFilter(event) {
        const checkbox = event.target.id;
        Filters.update((filters) => {
            filters[checkbox] = event.target.checked;
            return filters;
        });
    }

    const unsubscribe = Filters.subscribe(() => filterCreatures());

    onDestroy(unsubscribe);
</script>

<div>
    <h2>FILTERS</h2>
    <input
        placeholder="Search"
        bind:value={searchText}
        on:keyup={filterCreatures}
    />
    <DifficultyFilter />

    {#each ["frightening", "horrifying", "magic"] as filter}
        <label class="checkbox" class:active={$Filters[filter]}
            ><input
                type="checkbox"
                id={filter}
                on:change={setFilter}
            />{filter}</label
        >
    {/each}
</div>
